import React, { useState } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep, setShowPopUp, setFutureAccountType, setSelectedBan, setBanList, setGeneralMessage } from '../OwnershipTransferSlice';
import { getOrganizationBanNumbers } from '../../TransferOrganizationAccountBlock/TransferOrganizationAccountSlice';
import SelectOptionButton from '../../../Shared/SelectOptionButton/SelectOptionButton';
import { OwnershipTransferStep, FutureBusinessAccountType, MessageContent } from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

const FutureAccountType = (props) => {
  const [error, setError] = useState(false);
  const buttons = [
    {
      id: '0',
      label: 'במימון מלא של החברה',
      value: FutureBusinessAccountType.BusinessFullFunding,
      selected: props.data.futureAccountType === FutureBusinessAccountType.BusinessFullFunding ? true : false,
    },
    {
      id: '1',
      label: 'במימון מפוצל של החברה',
      value: FutureBusinessAccountType.BusinessSplit,
      selected: props.data.futureAccountType === FutureBusinessAccountType.BusinessSplit ? true : false,
    },
  ];
  async function setSelectedType(type) {
    props.setFutureAccountType(type);
    if (type == FutureBusinessAccountType.BusinessFullFunding) {
      const bans = await props.getOrganizationBanNumbers(props.portalsBlock.selectedHetPay);
      if (bans.payload.serverError) {
        props.setGeneralMessage(MessageContent.GeneralError);
        props.setCurrentStep(OwnershipTransferStep.GeneralMessage);
      }
      props.setBanList(bans);
    }
  }
  function nextStep() {
    if (!props.data.futureAccountType) {
      setError(true);
    } else {
      if (props.data.futureAccountType == FutureBusinessAccountType.BusinessSplit) {
        props.setCurrentStep(OwnershipTransferStep.CustomerForm);
      } else {
        if (props.data.banList.length > 0) {
          if (props.data.banList.length == 1) {
            props.setSelectedBan(props.data.banList[0].banNumber);
            props.setCurrentStep(OwnershipTransferStep.CustomerForm);
          } else {
            props.setCurrentStep(OwnershipTransferStep.BanSelecting);
          }
        } else {
          //there aren't available bans
          props.setGeneralMessage(MessageContent.AvailableBanError);
          props.setCurrentStep(OwnershipTransferStep.GeneralMessage);
        }
      }
    }
  }

  return (
    <div className='ownership-transfer-futureAccount-type  ownership-transfer-step'>
      <div className='stepContainer'>
        <div className='l-title '>מה יהיה סוג המימון של המנוי?</div>

        <div className=''>
          <SelectOptionButton buttonsData={buttons} onClick={setSelectedType} />
        </div>
      </div>
      <div className='continue-button'>
        {error && <div className='error center'>כדי להמשיך יש לבחור את סוג המנוי</div>}
        <BtnSubmit onclick={nextStep} text={'בחרתי, אפשר להמשיך'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  portalsBlock: state.portalsBlock,
});

const mapDispatchToProps = {
  setCurrentStep,
  setFutureAccountType,
  getOrganizationBanNumbers,
  setSelectedBan,
  setBanList,
  setGeneralMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(FutureAccountType);
